export { default as AppliedFilterBadge } from './AppliedFilterBadge';
